import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface ClientCredentialsResponseModel {
	readonly clientId: string;
	readonly clientSecret: string;
}

export const useClientCredentials = () => {
	const http = useHTTP("Required");

	return useHTTPQuery({
		queryKey: ["clientCredentials"],
		queryFn: () => http<ClientCredentialsResponseModel>({
			method: "GET",
			url: "/auth/client-credentials"
		})
	});
};
